import { useCallback, useEffect, useState } from "react";
import { handleApiError } from "../Utils/apiErrors";

/**
 * Carga datos de un servicio y avisa de los errores con handleApiError
 * (403, 409...). reload() vuelve a pedirlos, p. ej. tras crear o borrar.
 */
export const useApiData = <T = any>(service: () => Promise<any>) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    service()
      .then((response: any) => {
        if (active) setData(response.data);
      })
      .catch((error: any) => {
        if (active) handleApiError(error, { fallback: "No se han podido cargar los datos" });
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadKey]);

  const reload = useCallback(() => setReloadKey((key) => key + 1), []);

  return { data, loading, reload };
};
